export default class Translations {

    constructor(private translations: Translation[] = []) {
        this.translations = translations;
    }

    public get(key: string, ...args: []) {
        const translation = this.translations.find((entry) => entry.key === key);
        
        let translationString = '';

        

        if (typeof translation !== 'undefined') {
            translationString = translation.value;

            for (let index = 0; index < args.length; index++) {
                const tmp = index + 1;

                translationString = translationString.replace('{{' + tmp + '}}', args[index]);
            }

        } else {
            translationString = '---';
        }

        return translationString;
    }

    public length(){
        return this.translations.length;
    }

    public getElements(){
        return this.translations;
    }
}

export interface Translation {
    key: string;
    value: string;
}
